<template>
    <v-app id="inspire" :dark="dark">

        <v-layout row justify-center v-if="loading">
            <v-dialog v-model="loading" persistent fullscreen content-class="loading-dialog">
                <v-container fill-height>
                    <v-layout row justify-center align-center>
                        <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
                    </v-layout>
                </v-container>
            </v-dialog>
        </v-layout>

        <v-layout v-else>
            <left-nav :drawer="drawer"></left-nav>

            <v-toolbar v-if="user" app fixed clipped-left>
                <v-toolbar-side-icon @click.stop="nav()"></v-toolbar-side-icon>
                <v-toolbar-title>ŠTEDIŠA</v-toolbar-title>

                <v-spacer></v-spacer>


                <v-btn icon>
                    <v-icon @click="dropdown = !dropdown">more_vert</v-icon>
                </v-btn>

                <v-card
                        v-if="dropdown"
                        :close-on-content-click="false"
                        :nudge-width="200"
                        class="dropdown-menu"
                >

                    <v-list>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-switch v-model="dark" color="primary"></v-switch>
                            </v-list-tile-action>
                            <v-list-tile-title>Tamna tema</v-list-tile-title>
                        </v-list-tile>

                    </v-list>

                    <v-divider></v-divider>

                    <v-card-actions>

                        <v-btn color="primary" block @click="logout()">Odjava</v-btn>

                    </v-card-actions>
                </v-card>

            </v-toolbar>

            <v-content>

                <router-view></router-view>

            </v-content>
        </v-layout>

        <v-footer app fixed>
            <span>Nebojsa Markovic &copy; 2018</span>
        </v-footer>
    </v-app>
</template>

<script>
  import { theme_light_colors, theme_dark_colors } from 'colors';

  export default {
    data(){
      return {
        loading: false,
        dropdown: false,
        dark: false,
      }
    },
    computed: {
      drawer(){
        return this.$store.getters['nav/getShowLeftBar'] || false;
      },
      user(){
        return this.$store.getters['user/getUser'];
      },
    },
    methods: {
      nav(){
        this.$store.dispatch('nav/changeShowLeftBar');
      },
      logout(){
        this.$store.dispatch('nav/setShowLeftBar', false);
        this.$router.push('/logout');
      },
    },
    watch: {
      user(){
        if(this.user != null){
          this.dark = this.user.dark_theme? true : false;
        }
      },
      dark(){
        this.$store.dispatch('user/changeDarkTheme', this.dark);

        this.$vuetify.theme = this.dark ? theme_dark_colors : theme_light_colors;

        axios.post('users/change-dark-theme', { dark_theme: this.dark })
          .then(res => {
            // console.log(res.data.message);
          })
          .catch(e => {
            console.log(e.response.data);
          });
      },
    },
  }
</script>

<style>
    .dropdown-menu{
        position: absolute;
        right: 0;
        top: 70px;
    }
</style>
